<header class="quotation-header">
  <div class="left-side">
    <a (click)="getRoute()">
      <img class="main-logo" [src]="getImagePath+'logo.svg'" alt="Rio Logo" width="40px" height="auto">
    </a>
    <!-- <button class="btn toggle-icon d-block d-lg-none" type="button" data-bs-toggle="offcanvas"
      data-bs-target="#sideMenu" aria-controls="sideMenu">
      <img class="icon" [src]="getImagePath+'menu-icon.svg'" alt="menu">
    </button> -->
  </div>
  <div *ngIf="isStepperFormsRoute()" class="right-side">
    <div class="profile-btn" [matMenuTriggerFor]="profilemenu">
      <div class="mx-2">
        <img [src]="getImagePath + 'avatar.svg'" alt="user" class="avatar" />
      </div>
      <div class="align-items-center">
        <p class="user-name cursor-pointer">{{ userDetails?.vName }}</p>
      </div>
      <mat-menu #profilemenu="matMenu" class="header-matmenu header-matmenu_box">
        <button mat-menu-item [routerLink]="['/customer/profile']">Profile</button>
        <button mat-menu-item [routerLink]="['/customer/change-password']">Change Password</button>
        <button mat-menu-item (click)="HandleLogout()">Sign Out</button>
      </mat-menu>
    </div>
  </div>
</header>